import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';
import { convertToFormData } from 'utils/helpers';

export const fetchForms = ({ projectId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        // url: `forms/projects/${projectId}`,
        // params: {
        //     // project: projectId,
        //     offset,
        //     limit
        // }
        url: 'forms',
        params: {
            project_id: projectId,
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createForm = ({ automation, project_id, target_task_group_id, meta, success, multi_submit, fields }) => {
    return AjaxService({
        method: 'post',
        url: 'forms',
        data: {
            automation: automation ? automation : undefined,
            project_id,
            target_task_group_id,
            meta,
            success,
            multi_submit,
            fields
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchForm = (formId, token) => {
    return AjaxService({
        method: 'get',
        url: `forms/${formId}`
    }, false, token)
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateForm = (formId, { automation, target_task_group_id, meta, success, multi_submit, fields }) => {
    return AjaxService({
        method: 'post',
        url: `forms/${formId}`,
        data: {
            automation,
            target_task_group_id : target_task_group_id ? target_task_group_id : undefined,
            meta,
            success,
            multi_submit,
            fields
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeForm = formId => {
    return AjaxService({
        method: 'delete',
        url: `forms/${formId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const getFormResponses = formId => {
    return AjaxService({
        method: 'get',
        url: `forms/responses`,
        params: {
            form_id: formId
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const submitForm = (data, token) => {
    return AjaxService({
        method: 'post',
        url: 'forms/response',
        data: convertToFormData(data)
    }, false, token)
    .then(response => response.data)
    .catch(handleServerError);
}
